// extracted by mini-css-extract-plugin
export default {"wrapper":"Tabs_wrapper__LW2bK"};